import type { ReactNode } from 'react';
import { BillReviewStage } from './BillReviewStage.js';

/** The accounts check of a forwarded bill, once its commercial check has passed. */
export function AccountsReviewPage(): ReactNode {
  return (
    <BillReviewStage
      stage="accounts"
      checks={['invoiceComplianceOk', 'taxComplianceOk', 'supportingDocsOk', 'calculationAccuracyOk', 'accountingReadinessOk']}
      decisions={['APPROVE', 'REJECT', 'RETURN', 'ESCALATE']}
    />
  );
}
